








































import { Component, mixins, namespace } from 'nuxt-property-decorator'
import LazyHydrate from 'vue-lazy-hydration'
import { IImageVariants } from '~/assets/interfaces/images'
import MixinGeneral from '~/assets/mixins/general'

const siteStore = namespace('site')

@Component({
  components: {
    LazyHydrate,
    ComponentHeaderTopLineType2: () =>
      import('~/components/header/header-top-line-type-2.vue'),
    ComponentHeaderMainLineType2: () =>
      import('~/components/header/header-main-line-type-2.vue'),
    ComponentLogo: () => import('~/components/logo/logo.vue'),
    ComponentHeaderMenu: () => import('~/components/header/header-menu.vue'),
  },
})
export default class ComponentHeaderVariant11 extends mixins(MixinGeneral) {
  @siteStore.State('logo') private logo!: {
    image: IImageVariants | string
    aspectRatio?: string
  } | null

  @siteStore.Mutation('setFixedHeaderHeight') private setFixedHeaderHeight!: (
    height: number
  ) => void

  private isFixed = false
  private headerHeight = 142

  private makeFixed() {
    this.isFixed = window.scrollY > this.headerHeight
  }

  private addListener() {
    window.addEventListener('scroll', this.makeFixed)
  }

  private removeListener() {
    window.removeEventListener('scroll', this.makeFixed)
  }

  private mounted() {
    this.$emit('loaded')

    if (process.client) {
      const header = this.$refs.header as HTMLElement
      this.headerHeight = header.clientHeight

      this.setFixedHeaderHeight(116)

      this.makeFixed()
      this.addListener()
    }
  }

  private get classHeaderSticky() {
    return {
      [this.$style.headerSticky]: true,
      [this.$style.active]: this.isFixed,
    }
  }

  private beforeDestroy() {
    if (process.client) {
      this.removeListener()
    }
  }

  private get logoStyle() {
    return this.logo?.aspectRatio ? { aspectRatio: this.logo?.aspectRatio } : {}
  }
}
